import { classIf } from "../../data/utils";

export function getScores(data, descClass, scoreClass) {
    data = data?.formattedScores;
    if (data == null || data.length === 0) {
        return [null, null, null];
    }

    const periodDescs = new Set();
    const header = [], scoresTeam1 = [], scoresTeam2 = [];
    data.forEach((s, i) => {
        if (periodDescs.has(s.p)) {
            return;
        }
        periodDescs.add(s.p);
        header.push(<span key={i} className={descClass}>{s.p}</span>);
        scoresTeam1.push(<span key={i} className={scoreClass + classIf(i === 0, 'active')}>{s.s1}</span>);
        scoresTeam2.push(<span key={i} className={scoreClass + classIf(i === 0, 'active')}>{s.s2}</span>);
    });

    return [header, scoresTeam1, scoresTeam2];
}

export function getFullScores(periods, data, descClass, scoreClass) {
    const header = [], scoresTeam1 = [], scoresTeam2 = [];
    periods.forEach((p, i) => {
        header.push(<span key={i} className={descClass}>{p}</span>);
        let [score1, score2] = ['-', '-'];
        if (data?.has(p)) {
            const score = data.get(p);
            [score1, score2] = [score.s1, score.s2];
        }
        scoresTeam1.push(<span key={i} className={scoreClass + classIf(i === 0, 'active')}>{score1}</span>);
        scoresTeam2.push(<span key={i} className={scoreClass + classIf(i === 0, 'active')}>{score2}</span>);
    });

    return [header, scoresTeam1, scoresTeam2];
}
